import React from 'react'

import { Organization } from 'schema-dts'

import { DiningOptionBehavior } from 'src/apollo/onlineOrdering'
import { mergeSchedules, schemaOrgOpeninghours } from 'src/lib/js/schedule'
import SchemaThing from 'src/public/components/seo/SchemaThing'
import { getImageUrl } from 'src/shared/components/common/Image'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

import { buildPotentialActions } from 'public/components/seo/restaurantSchemaBuilder'

const LocationSelectionPageSchema = () => {
  const {
    restaurant: siteRestaurant,
    ooRestaurant,
    selectedLocation
  } = useRestaurant()
  const { meta, config } = siteRestaurant

  return (
    <SchemaThing<Organization>
      json={(routes) => ({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': routes.homeUrl,
        url: routes.homeUrl,
        name: siteRestaurant.name,
        brand: siteRestaurant.name,
        sameAs: meta.urls || undefined,
        ...(meta.icon ? { logo: getImageUrl(meta.icon) } : {}),
        ...(siteRestaurant.lastPublishedAt
          ? { dateModified: siteRestaurant.lastPublishedAt }
          : {}),
        subOrganization: siteRestaurant?.locations?.map((loc) => ({
          '@type': 'Restaurant',
          '@id': routes.orderUrl(loc.externalId),
          url: routes.orderUrl(loc.externalId),
          name: loc.name,
          description: meta.description,
          servesCuisine: meta.cuisine,
          paymentAccepted: meta.acceptedPaymentTypes,
          priceRange: meta.priceRange,
          telephone: loc.phoneNumber,
          address: {
            '@type': 'PostalAddress',
            addressCountry: loc.country || undefined,
            postalCode: loc.zipcode,
            addressRegion: loc.administrativeArea || loc.state,
            addressLocality: loc.city,
            streetAddress: loc.address2
              ? `${loc.address1}, ${loc.address2}`
              : loc.address1
          },
          ...(loc.lat && loc.long
            ? {
                geo: {
                  '@type': 'GeoCoordinates',
                  latitude: `${loc.lat}`,
                  longitude: `${loc.long}`
                }
              }
            : {}),
          ...(loc.reservationsUrl ? { acceptsReservations: true } : {}),
          openingHoursSpecification: schemaOrgOpeninghours(
            mergeSchedules(
              loc,
              undefined,
              !!config.isOnlineOrderingOnly,
              DiningOptionBehavior.TakeOut
            )
          ),
          image: siteRestaurant.meta.icon
            ? getImageUrl(siteRestaurant.meta.icon)
            : undefined,
          logo: siteRestaurant.meta.icon
            ? getImageUrl(siteRestaurant.meta.icon)
            : undefined,
          ...buildPotentialActions(
            loc.shortUrl ? routes.orderUrl(loc.externalId) : undefined,
            loc.reservationsUrl,
            // only load giftcard link for current location
            loc.externalId === selectedLocation?.externalId
              ? ooRestaurant?.giftCardLinks?.purchaseLink
              : undefined
          )
        }))
      })}
    />
  )
}

export default LocationSelectionPageSchema
